import type { FC } from "react";

import { Alert } from "@/ui/components/feedback/Alert";
import {
  Item,
  ItemActions,
  ItemContent,
  ItemMedia,
} from "@/ui/components/data-display/Item";
import { HeadedSection } from "@/ui/components/data-display/HeadedSection";
import { Button, Icon } from "@/ui/components/primitives";
import { TextEyebrow } from "@/ui/components/typography/TextEyebrow";

import {
  DELIVERY_DELAY_CARD_DEFAULTS,
  type TDeliveryDelayCardProps,
} from "./DeliveryDelayCard.config";
import { useDeliveryDelayCard } from "./useDeliveryDelayCard";

export const DeliveryDelayCard: FC<TDeliveryDelayCardProps> = ({
  expectedDelivery,
  alertText,
  onDelay,
  "data-component": component = DELIVERY_DELAY_CARD_DEFAULTS["data-component"],
}) => {
  const { title, expectedLabel, delayLabel } = useDeliveryDelayCard();

  return (
    <HeadedSection data-component={component} title={title} theme="fresh">
      <Item>
        <ItemMedia variant="icon">
          <Icon icon="orderDelivery" />
        </ItemMedia>
        <ItemContent>
          <TextEyebrow
            className="mb-1 uppercase !font-normal"
            color="secondary"
            tag="h3"
            child={{
              component: "subtitle",
              size: 2,
              children: expectedDelivery,
              isResponsive: false,
            }}
          >
            { expectedLabel }
          </TextEyebrow>
        </ItemContent>
        <ItemActions>
          <Button onClick={onDelay} variant="tertiary">{ delayLabel }</Button>
        </ItemActions>
      </Item>
      { alertText ? (
        <Alert asset="circleTick" variant="info">
          { alertText }
        </Alert>
      ) : null }
    </HeadedSection>
  );
};

DeliveryDelayCard.displayName = "DeliveryDelayCard";
